import React, { useEffect, useRef, useState } from "react";
import Colors from "../../useclass/colors";

const Breadcrumb = (props) => {
  const styles = {
    arrowModal: {
      marginRight: 10,
    },
    container: {
      width: "100%",
      marginTop: 15,
      marginBottom: 7,
      color: "#0D1E46",
      display: "flex",
      flexDirection: "row",
      fontSize: 14,
      alignItems: "center",
    },
    ctnBurger: {
      marginTop: "auto",
      paddingTop: 5,
      paddingBottom: 5,
      marginBottom: "auto",
      marginLeft: 30,
      zIndex: 10,
      marginRight: 50,
    },
    elem: {
      margin: 10,
    },
    home: {
      marginLeft: 20,
      marginRight: 10,
    },
    modal: {
      position: "absolute",
      top: 150,
      left: 0,
      backgroundColor: "#7CA8DF",
      width: 300,
      borderBottomRightRadius: 10,
      boxShadow: "5px 5px 2px rgba(0,0,0, 0.2)",
      // height: 365,
      display: "flex",
      flexDirection: "column",
      color: "white",
      zIndex: -5,
    },
    modalBody: {
      width: "90%",
      marginLeft: "auto",
    },

    modalBodyCtn: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "noWrap",
      alignItems: "center",
      marginTop: 0,
      marginBottom: 0,
    },
    modalBodyHome: {
      marginLeft: 20,
      marginTop: 60,
      marginBottom: 10,
      cursor: "pointer",
    },

    modalBottom: {
      width: "100%",
      marginTop: 20,
      borderTop: "1px white solid",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-evenly",
    },
    modalBodyTxt: {
      marginTop: 10,
      marginBottom: 10,
      cursor: "pointer",
    },
    slash: {
      marginLeft: 10,
      marginRight: 10,
    },
    txtAccount: {
      fontWeight: "bold",
      marginTop: 5,
      marginBottom: 10,
      marginLeft: 5,
      color: "white",
      textDecoration: "underline",
      texteDecorationColor: "white",
    },
    urlLink: {
      color: "#0D1E46",
      textDecoration: "none",
    },
    urlLinkHome: {
      color: "#0D1E46",
      textDecoration: "none",
    },
  };

  let test = window.location.href.split("/");

  test.reverse();
  test.pop();
  test.pop();
  test.pop();
  test.reverse();

  let latest = [];
  for (let i = 0; i < test.length; i++) {
    if (i % 1 === 0 && i !== 0 && isNumeric(test[i])) {
      latest[latest.length - 1] += " " + test[i];
    } else latest.push(test[i]);
    //console.log(latest)
  }

  for (let i = 0; i < test.length; i++) {
    if (isNumeric(test[i]) === true) {
      //console.log("number")
    }
  }

  function isNumeric(str) {
    if (typeof str != "string") return false;
    return !isNaN(str) && !isNaN(parseFloat(str));
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function pluralApplication(string) {
    if (string !== "Simulateur") return string + "s";
    else return string;
  }

  function isValid(string) {
    // if (!isNumeric(string)) {
    if (string.length > 1) return string;
    // }
  }

  const [stateOpenTopMenu, setStateOpenTopMenu] = useState(false);

  const handleChangeStateOpenTopMenu = async (setter, currentValue) => {
    if (currentValue === true) {
      setter(false);
    }
    if (currentValue === false) {
      setter(true);
    }
  };

  function disconnect() {
    localStorage.removeItem("efluser");
    localStorage.removeItem("remarque");
    localStorage.removeItem("currentEmol");
    localStorage.removeItem("chart");
    window.location = "/";
  }
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setStateOpenTopMenu(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  return (
    <div style={styles.container}>
      <div style={styles.ctnBurger} ref={wrapperRef}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="24"
          viewBox="0 0 35.643 26.494"
          onClick={(event) =>
            handleChangeStateOpenTopMenu(setStateOpenTopMenu, stateOpenTopMenu)
          }
          style={{ cursor: "pointer" }}
        >
          <circle
            cx="438"
            cy="438"
            r="438"
            fill="#fff"
            stroke="#fff"
            stroke-miterlimit="10"
          />
          <g
            id="Groupe_95"
            data-name="Groupe 95"
            transform="translate(-63.934 -18.422)"
          >
            <g
              id="Icon_feather-menu"
              data-name="Icon feather-menu"
              transform="translate(66.934 21.422)"
            >
              <path
                id="Tracé_4"
                data-name="Tracé 4"
                d="M4.5,18H34.143"
                transform="translate(-4.5 -7.753)"
                fill="none"
                stroke="#0D1E46"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="6"
              />
              <path
                id="Tracé_5"
                data-name="Tracé 5"
                d="M4.5,9H34.143"
                transform="translate(-4.5 -9)"
                fill="none"
                stroke="#0D1E46"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="6"
              />
              <path
                id="Tracé_6"
                data-name="Tracé 6"
                d="M4.5,27H34.143"
                transform="translate(-4.5 -6.506)"
                fill="none"
                stroke="#0D1E46"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="6"
              />
            </g>
          </g>
        </svg>

        {stateOpenTopMenu === true ? (
          <div style={styles.modal}>
            <div style={styles.modalBody}>
              <div style={styles.modalBodyCtn}>
                <p
                  style={styles.modalBodyHome}
                  onClick={(event) => (window.location = "/")}
                >
                  Accueil
                </p>
              </div>

              <div style={styles.modalBodyCtn}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="11.471"
                  viewBox="0 0 9 11.471"
                  style={styles.arrowModal}
                >
                  <path
                    id="Icon_ionic-md-arrow-dropright"
                    data-name="Icon ionic-md-arrow-dropright"
                    d="M13.5,9l9,5.736-9,5.736Z"
                    transform="translate(-13.5 -9)"
                    fill="#fbfbfb"
                  />
                </svg>
                <p
                  style={styles.modalBodyTxt}
                  onClick={(event) =>
                    (window.location = "/categorie/immobilier")
                  }
                >
                  Actes immobiliers
                </p>
              </div>

              <div style={styles.modalBodyCtn}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="11.471"
                  viewBox="0 0 9 11.471"
                  style={styles.arrowModal}
                >
                  <path
                    id="Icon_ionic-md-arrow-dropright"
                    data-name="Icon ionic-md-arrow-dropright"
                    d="M13.5,9l9,5.736-9,5.736Z"
                    transform="translate(-13.5 -9)"
                    fill="#fbfbfb"
                  />
                </svg>
                <p
                  style={styles.modalBodyTxt}
                  onClick={(event) => (window.location = "/categorie/famille")}
                >
                  Actes de la famille
                </p>
              </div>

              <div style={styles.modalBodyCtn}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="9"
                  height="11.471"
                  viewBox="0 0 9 11.471"
                  style={styles.arrowModal}
                >
                  <path
                    id="Icon_ionic-md-arrow-dropright"
                    data-name="Icon ionic-md-arrow-dropright"
                    d="M13.5,9l9,5.736-9,5.736Z"
                    transform="translate(-13.5 -9)"
                    fill="#fbfbfb"
                  />
                </svg>
                <p
                  style={styles.modalBodyTxt}
                  onClick={(event) => (window.location = "/categorie/prets")}
                >
                  Actes de prêt, garanties et mainlevées
                </p>
              </div>
            </div>

            <div style={styles.modalBottom}>
              <div>
                <a
                  href="https://notaire.efl.fr"
                  onClick={() => {
                    if (typeof window.gtag === "function") {
                      window.gtag("event", "click_retour_inneo", {
                        event_category: "Navigation",
                        event_label: "Retour sur Inneo",
                        value: 1,
                      });
                    }
                  }}
                >
                  <p style={styles.txtAccount}>Retour sur Inneo</p>
                </a>
              </div>
              <div style={styles.elem}>
                <svg
                  id="Calque_1"
                  data-name="Calque 1"
                  xmlns="http://www.w3.org/2000/svg"
                  width="59.09"
                  height="45"
                  viewBox="0 0 59.09 60"
                >
                  <path
                    d="m3.35,33.99c-2.21,0-3.67,1.76-3.2,3.92,0,0-.33-1.18.04.14,3.52,12.66,15.13,21.95,28.91,21.95,16.57,0,30-13.43,30-30C59.09,13.43,45.66,0,29.09,0,15.29,0,3.66,9.32.16,22.02c-.36,1.3-.02.08-.02.08-.44,2.16,1,3.92,3.2,3.92h25.08c.55,0,.68-.32.29-.71,0,0-3.24-3.23-4.42-4.39-3.81-3.79,1.85-9.43,5.62-5.67l12.15,12.21c1.36,1.37,1.37,3.6.01,4.97l-12.17,12.34c-3.77,3.76-9.43-1.88-5.66-5.64,1.21-1.19,4.46-4.43,4.46-4.43.39-.39.26-.71-.29-.71H3.35Z"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>

      <div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.369"
          height="21.826"
          viewBox="0 0 16.369 21.826"
        >
          <path
            id="Icon_awesome-map-marker-alt"
            data-name="Icon awesome-map-marker-alt"
            d="M7.343,21.385C1.15,12.406,0,11.485,0,8.185a8.185,8.185,0,0,1,16.369,0c0,3.3-1.15,4.221-7.343,13.2a1.024,1.024,0,0,1-1.682,0Zm.841-9.79a3.41,3.41,0,1,0-3.41-3.41A3.41,3.41,0,0,0,8.185,11.595Z"
            fill="#F6A86E"
          />
        </svg>
      </div>
      <div style={styles.home}>
        <a href={`/`} style={styles.urlLinkHome}>
          Accueil
        </a>
      </div>

      {isValid(latest[0]) ? (
        <>
          <div style={styles.slash}>/</div>

          {window.location.pathname === "/moncompte" ? (
            <div>Mon Compte</div>
          ) : (
            <div style={styles.slash}>
              {latest[0] === "fiches" ? (
                <a href={"/fiches"} style={styles.urlLink}>
                  <div>Fiches Pratiques</div>
                </a>
              ) : latest[0] === "categorie" ? (
                latest[1].includes("#") ? (
                  <a
                    href={
                      "/categorie/" +
                      latest[1].substring(0, latest[1].indexOf("#"))
                    }
                    style={styles.urlLink}
                  >
                    {latest[1].substring(0, latest[1].indexOf("#")) ===
                    "prets" ? (
                      <div>Prêts, garanties et mainlevées</div>
                    ) : (
                      capitalizeFirstLetter(
                        latest[1].substring(0, latest[1].indexOf("#"))
                      )
                    )}
                  </a>
                ) : (
                  <a href={"/categorie/" + latest[1]} style={styles.urlLink}>
                    {latest[1] === "prets" ? (
                      <div>Prêts, garanties et mainlevées</div>
                    ) : (
                      capitalizeFirstLetter(latest[1])
                    )}
                  </a>
                )
              ) : (
                <></>
              )}
            </div>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Breadcrumb;
